import React from "react";
import { useHistory } from "react-router-dom";
import { thousandFormat } from "../../actions/utiles";

function UseHistoryItem({ history }) {
  const link = useHistory();
  const linkToDetail = (params) => {
    link.push(`/use-history-detail/${params}`);
  };

  return (
    <>
      <tr key={history.id}>
        <th>
          <span className="txt-dark-gray">
            <span
              className="underline-black underline-hover-blue cursor"
              onClick={() => linkToDetail(`${history.id}/${history.service_type}`)}
            >
              {history.service_type === 0 ? "BC" : history.service_type === 1 ? "BR" : "BD"}{history.id}
            </span>
          </span>
        </th>
        <th>
          <span className="txt-dark-gray">
            {history.board_date ? history.board_date : "-"}{" "}
          </span>
        </th>
        <th>
          <span>{history.business_user_email}</span>
        </th>
        <th>
          <span className="txt-dark-gray">{history.business_user_name}</span>
        </th>
        <th>
          <span className="txt-dark-gray">
            {history.business_group_name
              ? history.business_group_name
              : "모든 그룹"}
          </span>
        </th>
        <th>
          <span className="txt-dark-gray">
            {history.is_tax_bill === 1 ? "세금계산서" : "카드"}
          </span>
        </th>
        <th>
          <span className="txt-dark-gray">
            {history.total_fare > 0
              ? thousandFormat(history.total_fare)
              : thousandFormat(history.fee)}
            원
          </span>
        </th>
        <th>
          <span className="txt-dark-gray">
            {history.status === 300 ? '운행완료' : '운행취소'}
          </span>
        </th>
      </tr>
    </>
  );
}

export default UseHistoryItem;
